import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Card, CardContent, CardHeader, Divider } from "@mui/material";

// ✅ Register the elements for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const ApplicationChart = ({ applist, appcount }) => {
  const data = {
    labels: applist,
    datasets: [
      {
        data: appcount,
        backgroundColor: [
          "#FF6384", "#76ff03", "#36A2EB", "#FFCE56", "#f44336",
          "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3",
          "#009688", "#4caf50", "#cddc39", "#8bc34a", "#64dd17",
          "#ffc107", "#ff9800", "#00c853", "#ff5722", "#795548", "#9e9e9e"
        ]
      }
    ]
  };

  const options = {
    cutout: "70%",
    maintainAspectRatio: false,
    responsive: true,
    elements: {
      arc: { borderWidth: 0 }
    }
  };

  return (
    <div>
      <br />
      <Card>
        <CardHeader title="Most Used Labs" />
        <Divider />
        <CardContent>
          <div style={{ width: "600px", height: "600px", margin: "auto" }}>
            <Doughnut data={data} options={options} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ApplicationChart;
